import React from "react";
import type { CardBrand } from "./types";

interface CardBrandIconProps {
  brand: CardBrand;
  width?: number;
  height?: number;
}

const VisaIcon: React.FC<{ width: number; height: number }> = ({ width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#visa_clip)">
      <path
        d="M5.1 6.18H18.9C19.69 6.18 20.32 6.81 20.32 7.59V16.33C20.32 17.11 19.69 17.75 18.91 17.75H5.09C4.31 17.75 3.68 17.11 3.68 16.33V7.6C3.68 6.81 4.3 6.18 5.09 6.18H5.1Z"
        fill="white"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="0.5"
      />
      <path
        d="M5.48 10.39C5.077 10.17 4.647 10.005 4.2 9.9L4.22 9.81H6.15C6.42 9.81 6.63 9.91 6.7 10.18L7.12 12.19L7.25 12.79L8.43 9.82H9.71L7.81 14.17H6.55L5.48 10.37V10.39ZM10.65 14.19H9.45L10.2 9.82H11.4L10.65 14.19ZM15.02 9.93L14.86 10.88L14.75 10.83C14.54 10.74 14.25 10.65 13.85 10.66C13.37 10.66 13.16 10.85 13.15 11.04C13.15 11.24 13.42 11.37 13.83 11.58C14.53 11.88 14.85 12.27 14.85 12.77C14.84 13.67 14.02 14.25 12.75 14.25C12.21 14.25 11.69 14.15 11.41 14.03L11.57 13.04L11.74 13.11C12.13 13.28 12.38 13.35 12.87 13.35C13.21 13.35 13.58 13.21 13.59 12.92C13.59 12.73 13.43 12.59 12.96 12.38C12.51 12.16 11.9 11.81 11.91 11.18C11.91 10.34 12.76 9.74 13.94 9.74C14.41 9.74 14.79 9.84 15.02 9.93ZM16.62 12.65H17.62L17.35 11.38L17.26 11L17.11 11.43L16.63 12.65H16.62ZM18.12 9.82L19.08 14.19H17.96L17.82 13.54H16.28L16.02 14.19H14.76L16.55 10.19C16.68 9.89 16.89 9.83 17.18 9.83H18.11V9.82H18.12Z"
        fill="#1434CB"
      />
    </g>
    <defs>
      <clipPath id="visa_clip">
        <rect width="17" height="12" fill="white" transform="translate(3.5 6)" />
      </clipPath>
    </defs>
  </svg>
);

const MastercardIcon: React.FC<{ width: number; height: number }> = ({ width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#mc_clip)">
      <path
        d="M18.5 6H5.5C4.39543 6 3.5 6.89543 3.5 8V16C3.5 17.1046 4.39543 18 5.5 18H18.5C19.6046 18 20.5 17.1046 20.5 16V8C20.5 6.89543 19.6046 6 18.5 6Z"
        fill="#0A2540"
      />
      <path
        d="M9.5 15.6C11.4882 15.6 13.1 13.9882 13.1 12C13.1 10.0118 11.4882 8.4 9.5 8.4C7.51178 8.4 5.9 10.0118 5.9 12C5.9 13.9882 7.51178 15.6 9.5 15.6Z"
        fill="#ED0006"
      />
      <path
        d="M14.3 15.6C16.2882 15.6 17.9 13.9882 17.9 12C17.9 10.0118 16.2882 8.4 14.3 8.4C12.3118 8.4 10.7 10.0118 10.7 12C10.7 13.9882 12.3118 15.6 14.3 15.6Z"
        fill="#F9A000"
      />
      <path
        d="M11.9 9.32C12.2765 9.658 12.5775 10.071 12.7837 10.533C12.9898 10.994 13.0963 11.494 13.0963 12C13.0963 12.506 12.9898 13.006 12.7837 13.468C12.5775 13.929 12.2765 14.342 11.9 14.68C11.5271 14.35 11.2271 13.946 11.0191 13.494C10.8112 13.041 10.6999 12.551 10.6923 12.053C10.6848 11.555 10.7812 11.061 10.9754 10.602C11.1696 10.144 11.4572 9.731 11.82 9.39L11.9 9.32Z"
        fill="#FF5D00"
      />
    </g>
    <defs>
      <clipPath id="mc_clip">
        <rect width="17" height="12" fill="white" transform="translate(3.5 6)" />
      </clipPath>
    </defs>
  </svg>
);

const AmexIcon: React.FC<{ width: number; height: number }> = ({ width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#amex_clip)">
      <path
        d="M18.5 6H5.5C4.39543 6 3.5 6.89543 3.5 8V16C3.5 17.1046 4.39543 18 5.5 18H18.5C19.6046 18 20.5 17.1046 20.5 16V8C20.5 6.89543 19.6046 6 18.5 6Z"
        fill="#016FD0"
      />
      <path
        d="M12.847 16.101V11.801L20.5 11.808V12.996L19.615 13.941L20.5 14.895V16.108H19.088L18.337 15.28L17.592 16.111L12.847 16.101Z"
        fill="white"
      />
      <path
        d="M13.358 15.63V12.275H16.203V13.047H14.279V13.572H16.157V14.332H14.279V14.847H16.203V15.63H13.358Z"
        fill="#016FD0"
      />
      <path
        d="M16.189 15.63L17.763 13.95L16.189 12.275H17.407L18.369 13.338L19.334 12.275H20.5V12.301L18.959 13.95L20.5 15.582V15.63H19.322L18.343 14.556L17.374 15.63H16.189Z"
        fill="#016FD0"
      />
      <path
        d="M13.204 7.985H15.049L15.697 9.456V7.985H17.974L18.367 9.087L18.761 7.985H20.5V12.285H11.309L13.204 7.985Z"
        fill="white"
      />
      <path
        d="M13.55 8.45L12.06 11.8H13.1L13.38 11.13H14.9L15.18 11.8H16.23L14.74 8.45H13.56H13.55ZM13.68 10.38L14.13 9.31L14.57 10.38H13.68Z"
        fill="#016FD0"
      />
      <path
        d="M16.201 11.804V8.451L17.637 8.457L18.375 10.517L19.119 8.451H20.5V11.804L19.611 11.812V9.509L18.772 11.804H17.961L17.104 9.501V11.804H16.201Z"
        fill="#016FD0"
      />
    </g>
    <defs>
      <clipPath id="amex_clip">
        <rect width="17" height="12" fill="white" transform="translate(3.5 6)" />
      </clipPath>
    </defs>
  </svg>
);

const GenericIcon: React.FC<{ width: number; height: number }> = ({ width, height }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 6.75H6C5.17157 6.75 4.5 7.42157 4.5 8.25V15.75C4.5 16.5784 5.17157 17.25 6 17.25H18C18.8284 17.25 19.5 16.5784 19.5 15.75V8.25C19.5 7.42157 18.8284 6.75 18 6.75Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4.5 10.5H19.5" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const BRAND_COMPONENTS: Record<string, React.FC<{ width: number; height: number }>> = {
  visa: VisaIcon,
  mastercard: MastercardIcon,
  amex: AmexIcon,
};

export const CardBrandIcon: React.FC<CardBrandIconProps> = ({ brand, width = 40, height = 40 }) => {
  const Component = BRAND_COMPONENTS[brand] || GenericIcon;
  return <Component width={width} height={height} />;
};
